var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loadingDiv",class:{ mask: _vm.mask },style:({ height: (_vm.height + "px") })},[_c('VueSimpleSpinner',{attrs:{"message":"Loading..."}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }